export default __webpack_public_path__ + "static/section_4_details_4-e92078cbf64c7fc7e88b9c9589e3e909.png";